import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";

interface TransactionModalProps {
  show: boolean;
  onClose: () => void;
  inprogressTransactions: number;
  pendingPaymentTransactions: number;
  pendingInspectionTransactions: number;
}

export const TransactionModal = ({
  show,
  onClose,
  inprogressTransactions,
  pendingPaymentTransactions,
  pendingInspectionTransactions,
}: TransactionModalProps) => {
  return (
    <Modal
      center
      open={show}
      onClose={onClose}
      classNames={{
        modalAnimationIn: "customEnterModalAnimation",
        modalAnimationOut: "customLeaveModalAnimation",
        modal: "customModal",
      }}
      animationDuration={500}
      aria-labelledby="summary-title"
      aria-describedby="summary-description"
    >
      <div className="container pb-3 mt-5">
        <div
          className="p-3 d-flex align-items-center gap-2 mb-2"
          style={{ background: "#FEFCE8", color: "#854D0E" }}
        >
          <i
            className="fa fa-triangle-exclamation"
            style={{ color: "#EFDB11" }}
          ></i>
          <p className="fw-bold fs-12">Attention needed</p>
        </div>
        {inprogressTransactions > 0 && (
          <p className="fs-14">
            You have <span className="fw-bold">{inprogressTransactions}</span>{" "}
            open {inprogressTransactions > 1 ? "transactions" : "transaction"}
          </p>
        )}
        {pendingPaymentTransactions > 0 && (
          <p className="fs-14">
            You have{" "}
            <span className="fw-bold">{pendingPaymentTransactions}</span>{" "}
            {pendingPaymentTransactions > 1 ? "transactions" : "transaction"}{" "}
            pending payment.
          </p>
        )}
        {pendingInspectionTransactions > 0 && (
          <p className="fs-14">
            You have{" "}
            <span className="fw-bold">{pendingInspectionTransactions}</span>{" "}
            {pendingInspectionTransactions > 1 ? "properties" : "property"}{" "}
            awaiting inspection.
          </p>
        )}
        <p className="fw-bold fs-13 text-secondary">
          Act now to complete or close the transaction to allow future property
          bookings.
        </p>
        <div className="d-flex">
          <Link
            to="/my-bookings"
            className="btn bg-primary rounded-pill px-md-5 py-2 text-white fw-bold mt-3"
          >
            Take Action
          </Link>
          <button
            className="btn rounded-pill px-md-5 py-2 text-secondary fs-13 mt-3 ml-3"
            onClick={onClose}
          >
            Do this later
          </button>
        </div>
      </div>
    </Modal>
  );
};
